<template>
  <Modal :id="'cmp-booking-questionnaire-lock-status'" @cancelled="onCancelClick">
    <template slot="header">{{$t('questionnaire_lock_status')}}</template>
    <template slot="body">
      <v-layout column>
        <v-flex :style="{ height: '150px' }">
          <NTable :id="'booking-questionnaire-lock-status-events'" :headers="eventHeaders" :items="eventDetails"
            :config="artistTableConfig">
            <template v-slot:thead="{ thcon, thtext }">
              <tr :style="{ paddingRight: trPaddingRight['edH'] }">
                <th v-for="(header, index) in eventHeaders" v-bind="thcon(header.value)" :key="header.value">
                  <div v-if="
                    index !== eventHeaders.length - 1 && header.value !== 'options'
                  " class="header-name">
                    {{ thtext(header.value) }}
                  </div>
                  <div v-else class="header-name">
                    <div class="dt-checkbox v2 s1" :title="$t('lock_unlock_all')" style="margin: auto 5px;">
                      <input type="checkbox" @click="(e) => onCheckboxChange(e, 'event_details_all')"
                        :checked="isSelectedAllEventData" />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:item="{ item, tdcon }">
              <tr :style="{ paddingRight: trPaddingRight['ed'] }">
                <td v-bind="tdcon('event_data')">
                  <span>{{ item["text"] }}</span>
                </td>
                <td v-bind="tdcon('options')" style="display:flex; flex-direction: row;">
                  <div class="dt-checkbox v2 s1" style="margin: auto 5px;">
                    <input type="checkbox" :checked="item['lock_status'] === 'lock'"
                      :title="item['lock_status'] === 'lock' ? $t('click_to_unlock') : $t('click_to_lock')"
                      @click="(e) => onCheckboxChange(e, 'event_detail', item)" />
                    <div class="checkmark"></div>
                  </div>
                  <img style="width:30px;"
                    :src="item['lock_status'] === 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
                    class="dt-icon" />
                </td>
              </tr>
            </template>
          </NTable>
        </v-flex>
        <v-flex :style="{ height: artistsBoxHeight, marginTop: '15px' }">
          <NTable :id="'booking-questionnaire-lock-status-artists'" :headers="artistHeaders" :items="artists"
            :config="artistTableConfig">
            <template v-slot:thead="{ thcon, thtext }">
              <tr :style="{ paddingRight: trPaddingRight['adH'] }">
                <th v-for="(header, index) in artistHeaders" v-bind="thcon(header.value)" :key="header.value">
                  <div v-if="
                    index !== artistHeaders.length - 1 && header.value !== 'options'
                  " class="header-name">
                    {{ thtext(header.value) }}
                  </div>
                  <div v-else class="header-name">
                    <div class="dt-checkbox v2 s1" :title="$t('lock_unlock_all')" style="margin: auto 5px;">
                      <input type="checkbox" @click="(e) => onCheckboxChange(e, 'artists_all')"
                        :checked="isSelectedAllArtist" />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:item="{ item, tdcon }">
              <tr :style="{ paddingRight: trPaddingRight['ad'] }">
                <td v-bind="tdcon('artist_details')">
                  <span>{{ item["artist_name"] }}</span>
                </td>
                <td v-bind="tdcon('options')" style="display:flex; flex-direction: row;">
                  <div class="dt-checkbox v2 s1" style="margin: auto 5px;">
                    <input type="checkbox" :checked="item['lock_status'] === 'lock'"
                      :title="item['lock_status'] === 'lock' ? $t('click_to_unlock') : $t('click_to_lock')"
                      @click="(e) => onCheckboxChange(e, 'artist', item)" />
                    <div class="checkmark"></div>
                  </div>
                  <img style="width:30px;"
                    :src="item['lock_status'] === 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
                    class="dt-icon" />
                </td>
              </tr>
            </template>
          </NTable>
        </v-flex>
        <v-flex :style="{ height: localDetailsBoxHeight, marginTop: '15px' }">
          <NTable :id="'booking-questionnaire-lock-status-local_details'" :headers="localDetailHeaders"
            :items="localDetails" :config="artistTableConfig">
            <template v-slot:thead="{ thcon, thtext }">
              <tr :style="{ paddingRight: trPaddingRight['ldH'] }">
                <th v-for="(header, index) in localDetailHeaders" v-bind="thcon(header.value)" :key="header.value">
                  <div v-if="
                    index !== localDetailHeaders.length - 1 && header.value !== 'options'
                  " class="header-name">
                    {{ thtext(header.value) }}
                  </div>
                  <div v-else class="header-name">
                    <div class="dt-checkbox v2 s1" :title="$t('lock_unlock_all')" style="margin: auto 5px;">
                      <input type="checkbox" @click="(e) => onCheckboxChange(e, 'local_details_all')"
                        :checked="isSelectedAllLocalDetails" />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:item="{ item, tdcon }">
              <tr :style="{ paddingRight: trPaddingRight['ld'] }">
                <td v-bind="tdcon('local_details')">
                  <span>{{ item["local_details_type_name"] }}</span>
                </td>
                <td v-bind="tdcon('name')">
                  <span>{{ item["name"] }}</span>
                </td>
                <td v-bind="tdcon('artists')">
                  <span>{{ item["artists"] }}</span>
                </td>
                <td v-bind="tdcon('pax')">
                  <span>{{ item["pax"] }}</span>
                </td>
                <td v-bind="tdcon('options')" style="display:flex; flex-direction: row;">
                  <div class="dt-checkbox v2 s1" style="margin: auto 5px;">
                    <input type="checkbox" :checked="item['lock_status'] === 'lock'"
                      :title="item['lock_status'] === 'lock' ? $t('click_to_unlock') : $t('click_to_lock')"
                      @click="(e) => onCheckboxChange(e, 'local_detail', item)" />
                    <div class="checkmark"></div>
                  </div>
                  <img style="width:30px;"
                    :src="item['lock_status'] === 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
                    class="dt-icon" />
                </td>
              </tr>
            </template>
          </NTable>
        </v-flex>
      </v-layout>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick"> {{$t('cancel')}} </button>
      <button class="dt-button v1 s6" @click="onOkClick"> {{$t('ok')}} </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

import SearchList from "@dtplugins/search-list/search-list";
import { overviewService } from "../../services/booking-details/booking-overview.service";
// import { openWindow } from "../../../../utility";
// import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
// import { copyToClipboard } from "../../../../dt-plugins/clipboard/clipboard";
// import { overviewService } from '../../services/booking-details/booking-overview.service';
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";

export default {
  components: {
    SearchList,
    Modal,
  },
  props: ["booking"],
  data: function () {
    return {
      artists: [],
      localDetails: [],
      eventDetails: [],
      lockStatus: {},
      tableDefaultRows: 8, // Display maximum 8 number of rows in a table.
    };
  },
  mounted: async function () {
    const lockStatusData = await overviewService.getQuestionnaireLockStatusModalData(
      this.$route.params.calendar_date_id
    );
    // console.log('lockStatusData', lockStatusData.data);
    this.artists = lockStatusData.data.cdate_artists;
    this.localDetails = lockStatusData.data.local_details;
    this.lockStatus = lockStatusData.data.lock_json;

    const eventDetails = [
      { key: "event", text: "EVENT DETAILS", lock_status: "" },
      { key: "venue", text: "VENUE / FESTIVAL DETAILS", lock_status: "" },
      { key: "contact", text: "CONTACT", lock_status: "" },
      { key: "promoter", text: "PROMOTER COMPANY / BUSINESS DETAILS", lock_status: "" },
    ];

    this.eventDetails = eventDetails.map(row => {
      row.lock_status = lockStatusData.data.lock_json[`calendar_dates_${row.key}`] ?? "";
      return row;
    });
  },
  computed: {
    artistTableConfig: function () {
      return createNTableConfig({
        headerStyle: 1,
        fullHeight: true,
        rowHeight: 30
      });
    },
    eventHeaders: function () {
      return [
        createTableHeader("event_data", { fw: 700, c: 'black', text: "Event Data" }),
        createTableHeader("options", { text: false, mw: 60 })
      ];
    },
    artistHeaders: function () {
      return [
        createTableHeader("artist_details", { fw: 700, c: 'black' }),
        createTableHeader("options", { text: false, mw: 60 })
      ];
    },
    artistsBoxHeight: function () {
      return this.getTableBoxHeight(this.artists.length);
    },
    localDetailsBoxHeight: function () {
      return this.getTableBoxHeight(this.localDetails.length);
    },
    trPaddingRight: function () {
      let isScrolled = false;
      if (this.artists.length > this.tableDefaultRows || this.localDetails.length > this.tableDefaultRows) {
        isScrolled = true;
      }
      const scrollbarWidth = this.getScrollbarSize();
      return isScrolled ? {
        edH: `${scrollbarWidth}px`,
        ed: `${scrollbarWidth}px`,
        adH: `${scrollbarWidth}px`,
        ad: this.artists.length > this.tableDefaultRows ? '0' : `${scrollbarWidth}px`,
        ldH: `${scrollbarWidth}px`,
        ld: this.localDetails.length > this.tableDefaultRows ? '0' : `${scrollbarWidth}px`,
      } : {
        edH: '0',
        ed: '0',
        adH: '0',
        ad: '0',
        ldH: '0',
        ld: '0',
      }
    },
    localDetailHeaders: function () {
      return [
        createTableHeader("local_details", { fw: 700, c: 'black' }),
        createTableHeader("name"),
        createTableHeader("artists"),
        createTableHeader("pax"),
        createTableHeader("options", { text: false, mw: 60 })
      ];
    },
    isSelectedAllEventData: function () {
      return this.eventDetails.length != 0 && (this.eventDetails.length == this.eventDetails.filter(item => item.lock_status == 'lock').length);
    },
    isSelectedAllArtist: function () {
      return this.artists.length != 0 && (this.artists.length == this.artists.filter(item => item.lock_status == 'lock').length);
    },
    isSelectedAllLocalDetails: function () {
      return this.localDetails.length != 0 && (this.localDetails.length == this.localDetails.filter(item => item.lock_status == 'lock').length);
    }
  },
  methods: {
    onCheckboxChange: function (e, type, item) {
      // console.log("WERE", e.target.checked);
      const checked = e.target.checked;

      if (type == "local_details_all") {
        this.localDetails = this.localDetails.map(row => {
          row.lock_status = checked ? "lock" : "";
          return row;
        });
      }
      else if (type == "local_detail") {
        this.localDetails = this.localDetails.map(row => {
          if (row.local_detail_id == item.local_detail_id) {
            row.lock_status = checked ? "lock" : "";
          }
          return row;
        });
      }
      else if (type == "artists_all") {
        this.artists = this.artists.map(row => {
          row.lock_status = checked ? "lock" : "";
          return row;
        });
      }
      else if (type == "artist") {
        this.artists = this.artists.map(row => {
          if (row.calendar_date_artist_id == item.calendar_date_artist_id) {
            row.lock_status = checked ? "lock" : "";
          }
          return row;
        });
      }
      else if (type == "event_details_all") {
        this.eventDetails = this.eventDetails.map(row => {
          row.lock_status = checked ? "lock" : "";
          return row;
        });
      }
      else if (type == "event_detail") {
        this.eventDetails = this.eventDetails.map(row => {
          if (row.key == item.key) {
            row.lock_status = checked ? "lock" : "";
          }
          return row;
        });
      }
    },
    onOkClick: async function () {
      let preparedLockJson = {};
      this.eventDetails.forEach(row => {
        if (row.lock_status == "lock") {
          preparedLockJson[`calendar_dates_${row.key}`] = "lock";
        }
      });

      this.artists.forEach(row => {
        if (row.lock_status == "lock") {
          preparedLockJson[`calendar_date_artists_${row.calendar_date_artist_id}`] = "lock";
        }
      });

      this.localDetails.forEach(row => {
        if (row.lock_status == "lock") {
          preparedLockJson[`local_details_${row.local_detail_id}`] = "lock";
        }
      });

      // console.log("preparedLockJson", preparedLockJson);

      this.$emit("changed", { name: 'lock_json', value: JSON.stringify(preparedLockJson) });
      this.onCancelClick();
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    getTableBoxHeight: function (rows) {
      let rowsWithHeader = rows + 1;
      rowsWithHeader = rowsWithHeader > 9 ? 9 : rowsWithHeader;
      let rowHeight = rowsWithHeader * 30;
      return `${rowHeight}px`;
    },
    getScrollbarSize: function () {
      const scrollDiv = document.createElement("div");
      
      scrollDiv.style.overflow = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-99999px";

      document.body.appendChild(scrollDiv);

      // Get the scrollbar width
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

      // Delete the DIV
      document.body.removeChild(scrollDiv);

      return scrollbarWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
// .relationTypes-container {}
</style>
